<!-- section template -->
<template>
  <section
    id="sectionService"
    ref="service"
    :class="[
      $style.sectionPrice,
      $style[`isStyle${formatTextUpperCasefirst(type)}`],
      {
        [$style['isStyleDingBeauty']]: $globalIsDingBeauty,
      },
    ]"
    class="section"
  >
    <div v-if="type === 'home'" :class="[$style.categoryMenu, { [$style.isFixed]: $globalScrollTop > serviceOffsetTop }]">
      <ValidationObserver>
        <el-form ref="form" :model="submitData" label-position="top" class="isStyleReservation">
          <div class="row">
            <div class="col-6 categoryMenu__type">
              <ValidationProvider v-slot="{ errors }" name="分店" rules="require">
                <el-form-item :error="errors[0]" prop="storeAlias" label="分店">
                  <el-select v-model="submitData.storeAlias" placeholder="請選擇分店" @change="onChengeSelect">
                    <el-option-group v-if="!!storeOpenStoreOptions[0]"  label="店面服務">
                      <el-option v-for="(option, $index) in storeOpenStoreOptions" :key="`storeOpenStoreOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                    </el-option-group>
                    <el-option-group v-if="!!storeOpenHomeOptions[0]" label="到府服務">
                      <el-option v-for="(option, $index) in storeOpenHomeOptions" :key="`storeOpenHomeOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </div>
            <div v-if="categoryOptions.length > 1" class="col-6 categoryMenu__category">
              <ValidationProvider v-slot="{ errors }" name="類型" rules="require">
                <el-form-item :error="errors[0]" prop="categoryAlias" :label="$t('site.USER')">
                  <el-select v-model="submitData.categoryAlias" placeholder="請選擇類型" @change="onChengeSelect">
                    <el-option v-for="(option, $index) in categoryOptions" :key="`categoryOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                  </el-select>
                </el-form-item>
              </ValidationProvider>
            </div>
          </div>
        </el-form>
      </ValidationObserver>
    </div>
    <div class="container">
      <div class="row">
        <div class="sectionPrice__serviceBox col-md-5 col-xl-5">
          <div class="sectionPrice__serviceContent">
            <BaseSectionTitleJtails v-if="type === 'home'" :title="$t('site.HOME_PRICE_TITLE')" :sub-title="$t('site.HOME_PRICE_SUBTITLE')" />
            <!-- <div v-if="$globalIsDingBeauty" class="sectionPrice__divider"></div> -->
            <div :class="[{ [$style['isFormDingbeauty']]: $globalIsDingBeauty }]">
              <!-- 上面select -->
              <ValidationObserver>
                <el-form ref="form" :model="submitData" label-position="top" class="isStyleBase mb-2">
                  <div class="row">
                    <div v-if="type === 'home'" :class="currentMerchant.petCategories.length > 1 ? 'col-md-6' : 'col-12'">
                      <ValidationProvider v-slot="{ errors }" name="分店" rules="require">
                        <el-form-item :error="errors[0]" prop="storeAlias" label="分店">
                          <el-select v-model="submitData.storeAlias" placeholder="請選擇分店" :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }" @change="onChengeSelect">
                            <el-option-group v-if="!!storeOpenStoreOptions[0]" label="店面服務">
                              <el-option v-for="(option, $index) in storeOpenStoreOptions" :key="`storeOpenStoreOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                            </el-option-group>
                            <el-option-group v-if="!!storeOpenHomeOptions[0]" label="到府服務">
                              <el-option v-for="(option, $index) in storeOpenHomeOptions" :key="`storeOpenHomeOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                            </el-option-group>
                          </el-select>
                        </el-form-item>
                      </ValidationProvider>
                    </div>

                    <div v-if="currentMerchant.petCategories.length > 1" :class="type === 'home' ? 'col-md-6' : 'col-md-12'">
                      <ValidationProvider v-slot="{ errors }" :name="$t('site.FORM_CATEGORY')" rules="require">
                        <el-form-item :error="errors[0]" prop="categoryAlias" :label="$t('site.FORM_CATEGORY')">
                          <el-select
                            v-model="submitData.categoryAlias"
                            :placeholder="`請選擇${$t('site.FORM_CATEGORY')}`"
                            :class="{ 'isStyleDingBeauty isUnderLine': $globalIsDingBeauty }"
                            @change="onChengeSelect"
                          >
                            <el-option v-for="(option, $index) in categoryOptions" :key="`categoryOptions-${$index}`" :label="option.text" :value="option.value"> </el-option>
                          </el-select>
                        </el-form-item>
                      </ValidationProvider>
                    </div>
                  </div>
                </el-form>
              </ValidationObserver>
              <!-- 服務項目列表 -->
              <template v-if="!!serviceDataList[0]" style="padding-left: 40px; padding-right: 40px">
                <PriceSelect v-model="submitData" :service-list="serviceDataList" :loading="$isLoading('fetchReservationPrice')" @change="setActivePrice" />
              </template>
              <template v-else>
                <span class="text-gray-2">尚無任何服務項目</span>
              </template>
              <BasePre>{{ submitData }}</BasePre>
            </div>
          </div>
        </div>

        <div class="sectionPrice__priceBox col-md-7 col-xl-6 offset-lg-0 offset-xl-1">
          <div class="sectionPrice__priceBoxBackground"></div>
          <div :class="[$style.priceBox, { [$style['isPriceBoxDingBeauty']]: priceBoxPaddingSet }]">
            <div id="sectionPrice" style="position: relative; top: -4rem"></div>
            <div
              v-if="priceBoxPaddingSet"
              class="priceBox__img"
              :style="{
                backgroundImage: `url('${priceList[0].image && priceList[0].image.path ? priceList[0].image.path : require(`@assets/images/${$globalProjectName}/default/plan-default-Image@2x.png`)}`,
              }"
            ></div>
            <h3 v-if="$globalIsJtails" class="priceBox__title" v-html="priceBoxTitle"></h3>
            <template v-if="!!priceList[0]">
              <div v-if="$globalIsJtails">
                <PriceCollapse v-model="activePrice" :price-list="priceList" :store-alias="submitData.storeAlias" />
              </div>
              <div v-if="$globalIsDingBeauty" class="priceBox__container">
                <div class="priceBox__container__fakeBg">
                  <h3 class="priceBox__title" v-html="priceBoxTitle"></h3>
                  <PriceCollapse v-model="activePrice" class="priceBox__list" :price-list="priceList" :store-alias="submitData.storeAlias" />
                </div>
              </div>
            </template>
            <template v-else>
              <BaseNull v-if="$globalIsJtails" :image="`${require('@assets/images/reservation/no-record.svg')}`" title="尚無任何服務項目" />
              <BaseNull v-if="$globalIsDingBeauty" :image="`${require('@assets/images/dingbeauty/default/no_reservation.svg')}`" title="尚無任何服務項目" />
            </template>
          </div>
        </div>
      </div>
      <BasePre>serviceOffsetTop: {{ serviceOffsetTop }}</BasePre>
    </div>
  </section>
</template>

<script>
import _findIndex from 'lodash/findIndex'
import { getDefaultCategory, getDefaultStore } from '@utils/ipetbooking-get-default'
import { categoryOptions, getCategoryOption, getStoreOption, storeOptions } from '@utils/ipetbooking-options'
import formatTextUpperCasefirst from '@utils/format-text-upper-casefirst'
import { merchantComputed } from '@store/helpers'

export default {
  components: {
    PriceSelect: () => import('@components/Price/PriceSelect'),
    PriceCollapse: () => import('@components/Price/PriceCollapse'),
    // PriceSingle: () => import("@components/Price/PriceSingle"),
  },
  props: {
    serviceList: {
      type: Array,
      default: () => {
        return [
          {
            title: 'A. 小美容',
            description: '洗澡小美容服務項目包含：剪指甲／剃腳底毛／剃肛門毛／剃肚子毛／清耳朵／擠肛門腺／小修足緣／小修臉部雜毛',
            items: [
              {
                title: '迷你 (3kg以下)',
                alias: 'alias1',
                price: 900,
                serviceTime: 90,
              },
            ],
          },
        ]
      },
    },
    storeAlias: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'home',
      validator(value) {
        return ['home', 'store'].includes(value)
      },
    },
    serviceType: {
      type: String,
      default: 'cosmetic',
      validator(value) {
        return ['cosmetic', 'daycare'].includes(value)
      },
    },
  },
  data() {
    return {
      submitData: {
        storeAlias: this.storeAlias || getDefaultStore(this.$route.query.serviceStore),
        categoryAlias: getDefaultCategory(this.$route.query.serviceCategory),
        service: '',
      },
      activeService: '',
      activePrice: 0,
      serviceDataList: this.serviceList,
      serviceOffsetTop: 0,
      storeOpenStoreOptions: Object.freeze(
        storeOptions({
          type: 'open',
          storeType: 'store',
        })
      ),
      storeOpenHomeOptions: Object.freeze(
        storeOptions({
          type: 'open',
          storeType: 'home',
        })
      ),
      categoryOptions: Object.freeze(categoryOptions()),
    }
  },

  computed: {
    ...merchantComputed,
    priceBoxPaddingSet() {
      return this.$globalIsDingBeauty && !!this.priceList[0]
    },
    priceList() {
      const index = _findIndex(this.serviceDataList, (item) => {
        return item.title === this.submitData.service.title
      })

      return index !== -1 ? this.serviceDataList[index].items : []
    },
    priceBoxTitle() {
      const storeTitle = getStoreOption({
        value: this.submitData.storeAlias,
        key: 'title',
      })

      const categoryTitle = getCategoryOption({
        value: this.submitData.categoryAlias,
        key: 'title',
      })

      const serviceTitle = this.submitData.service.title ? `${this.submitData.service.title}` : ''
      if (this.$globalIsDingBeauty) {
        return storeTitle && serviceTitle ? `${storeTitle}  - ${serviceTitle}` : ''
      } else {
        return storeTitle && categoryTitle && serviceTitle ? `${storeTitle} - ${categoryTitle} - ${serviceTitle}` : ''
      }
    },
  },
  mounted() {
    const initResizeListener = () => {
      window.addEventListener('resize', this.setServiceOffsetTop)
    }

    const initServiceOffsetTop = () => {
      this.setServiceOffsetTop()
      setTimeout(() => {
        this.setServiceOffsetTop()
      }, 600)
    }

    this.setActiveService()
    initServiceOffsetTop()
    initResizeListener()
  },
  destroyed() {
    const removeResizeListener = () => {
      window.removeEventListener('resize', this.setServiceOffsetTop)
    }

    removeResizeListener()
  },
  methods: {
    formatTextUpperCasefirst,
    setServiceOffsetTop() {
      this.serviceOffsetTop = this.$refs.service.offsetTop + 100
    },
    onChengeSelect() {
      const scrollToService = () => {
        const activeBreakpointList = ['xs', 'sm', '2sm', 'md']
        const isIncludesActiveBreakpointList = activeBreakpointList.includes(this.$globalBreakpoint)
        const isFixed = this.$globalScrollTop > this.serviceOffsetTop

        if (isIncludesActiveBreakpointList && isFixed) {
          this.$scrollToElement({
            $el: this.$refs['service'],
            offset: -105,
          })
        }
      }

      this.tryToFetchBookingPriceList()
      scrollToService()
    },
    tryToFetchBookingPriceList() {
      this.$store
        .dispatch('merchant/fetchReservationPrice', {
          storeAlias: this.submitData.storeAlias,
          categoryAlias: this.submitData.categoryAlias,
          types: [this.serviceType],
        })
        .then(({ items }) => {
          this.serviceDataList = items
          this.setActiveService()
        })
    },
    setActiveService() {
      this.submitData.service = this.serviceDataList[0] || {}

      this.setActivePrice()
    },
    setActivePrice() {
      this.activePrice = this.priceList.length > this.activePrice ? this.activePrice : 0
    },
    getDefaultImage(images) {
      const defaultImageItems = images.filter((image) => image.default) || []

      return defaultImageItems[0]?.path || ''
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
$price-box-height: 850px;
$price-box-width: 684px;

.sectionPrice {
  position: relative;

  &::after {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 2;
    font-family: $font-fontello;
    font-size: 50px;
    color: $color-primary;
    content: $fontello-decoration;
    transform: translate(-50%, -50%);
  }

  &::before {
    @media (max-width: $container) {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      content: '';
      background-image: linear-gradient(to right, rgba($color-primary, 0.1), rgba($color-primary, 0.1)), url('@assets/images/layout/bg-marble.jpg');
      background-position: center;
      background-size: cover;
    }
  }

  &.isStyleStore {
    @include max-lg {
      padding-top: 0;
    }

    &::after {
      @include max-lg {
        display: none;
      }
    }

    &::before {
      @include max-lg {
        top: -123px;
        background-color: rgba(#efe5e0, 0.3);
        background-image: none;
      }
    }
  }

  &.isStyleDingBeauty {
    background-color: #f5f6f9;
    min-height: 1070px;
    @include max-lg {
      min-height: auto;
    }

    &::after {
      display: none;
    }

    &::before {
      background-image: none;
      background-color: $color-bg-default;
    }

    :global {
      .sectionPrice {
        &__serviceContent {
          &::before {
            background-image: none;
            // background-color: $color-bg-default;
          }
        }
      }

      .sectionPrice__priceBox {
        z-index: 0;

        @media (min-width: 1500px) {
          position: absolute;
          left: 400px;
          padding-left: 150px;

          > div:nth-child(2) {
            height: 850px;
            width: 684px;
          }
        }

        @media (min-width: 1200px) and (max-width: 1500px) {
          position: relative;
          left: -60px;

          > div {
            height: 850px;
            width: 684px;
          }
        }

        @media (max-width: 1200px) {
          width: 100%;
          left: unset;
        }
      }

      .sectionPrice__serviceBox {
        z-index: 1;

        @media (min-width: 1500px) {
          width: 684px;
        }

        @media (max-width: 1500px) {
          width: 41.6%;
        }

        @media (max-width: 1200px) {
          width: 100%;
          margin-bottom: 10px;
        }
      }

      .sectionPrice__priceBoxBackground {
        position: absolute;
        background-color: $color-primary;
        right: -235px;
        top: 20px;

        @media (max-width: 1500px) {
          right: 0;
          top: 21px;
        }
        @media (min-width: 1500px) {
          height: 850px;
          width: 709px;
        }
        @media (min-width: 1200px) and (max-width: 1250px) {
          right: calc((734px - 100%) * -0.6 + (100% - 684px) * -0.05);
          top: 21px;
        }
        @media (max-width: 1200px) {
          display: none;
        }
      }

      .sectionPrice {
        &__serviceContent {
          position: relative;

          &::before {
            display: none;
          }
        }
      }

      .priceBox__img {
        height: 50%;
        background-size: cover;
        background-position: center center;
      }

      .priceBox__container {
        height: 50%;
        // background-color: $color-primary;
        > div > div {
          height: 20%;
        }
        &__fakeBg {
          padding: 3.125rem 3.125rem 20px;
        }
        :global {
          h3 {
            color: white;
          }
          .priceList__price {
            color: white;
          }
          .priceList__time {
            color: white;
          }
          .priceList__name {
            color: white;
          }
          .el-collapse-item__wrap {
            * {
              color: white;
            }
          }
          .el-icon-arrow-right::before {
            color: white;
          }
        }
      }

      .priceBox__list {
        > div {
          min-height: unset;
          height: 300px;
          overflow: scroll;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        :global {
          .el-collapse-item__wrap {
            background-color: rgba(0, 0, 0, 0);
          }
          .el-collapse-item__header {
            background-color: rgba(0, 0, 0, 0);
          }
        }
      }
    }
  }

  // background-image: linear-gradient(to right, rgba($color-secondary, 0.1), rgba($color-secondary, 0.1)), url('~@assets/images/layout/bg-marble.jpg');

  :global {
    .sectionPrice {
      &__serviceContent {
        position: relative;

        &::before {
          position: absolute;
          top: -$section-padding;
          right: calc(((-100vw + #{$container - ($container-gap * 2)}) / 2) - #{$container / 12 * 7} + 10px);
          bottom: -5rem;
          left: calc((-100vw + #{$container - ($container-gap * 2)}) / 2);
          z-index: -1;
          content: '';
          background-image: linear-gradient(to right, rgba($color-primary, 0.1), rgba($color-primary, 0.1)), url('~@assets/images/layout/bg-marble.jpg');
          background-position: center;
          background-size: cover;

          @media (max-width: $container) {
            display: none;
          }
        }
      }

      &__serviceBox {
        position: relative;
        z-index: 0;
      }

      &__priceBox {
        @include unstyled;
      }

      // &__divider {
      //   height: 1px;
      //   width: 75px;
      //   border: 1px solid $color-primary;
      //   margin-bottom: 18px;
      //   @media (max-width: 768px) {
      //       display: none;
      //   }
      // }
    }
  }
}

.categoryMenu {
  display: none;

  @include max-md {
    position: sticky;
    top: -100px;
    display: block;
    height: 51px;
    overflow: hidden;
    pointer-events: none;
    opacity: 0;

    &.isFixed {
      top: 60px;
      left: 0;
      z-index: $z-index-fixed-top-form;
      display: block;
      width: 100vw;
      padding-right: $container-gap;
      padding-left: $container-gap;
      margin-left: -$container-gap;
      pointer-events: auto;
      background-color: #fff;
      border-bottom: $color-gray-4 1px solid;
      opacity: 1;
      transition: top 0.3s;

      // stylelint-disable selector-class-pattern
      :global {
        .el-form-item {
          margin-bottom: 0;
        }

        .el-form-item__label {
          display: none;
        }

        .el-input__inner {
          height: 50px;
          border-bottom: 0 !important;
        }
      }

      // stylelint-enable selector-class-pattern
    }
  }

  :global {
    .categoryMenu {
      &__type {
        @include unstyled;
      }

      &__category {
        border-left: $color-gray-4 1px solid;
      }
    }
  }
}

.isFormDingbeauty {
  box-shadow: 2px 8px 36px #1c2c5414;
  padding: 50px 40px;
  background-color: white;
  max-height: 770px;

  > div {
    @media (min-width: 768px) {
      height: 765px;
    }
    @media (max-width: 767px) {
      height: 80px;
    }
  }

  :global {
    .dingBeautySelectStyle {
      :global {
        .el-input__inner {
          border-top: none;
          border-left: none;
          border-right: none;
          border-bottom: 1px solid #646a6f;
          padding-left: 1px;
        }
      }
    }

    ul {
      max-height: 520px;
      overflow: auto;
    }
  }
}

.priceBox {
  position: relative;
  padding: 3.125rem;
  background: #fff;
  box-shadow: 2px 8px 36px #1c2c5414;

  @include max-xl {
    padding: 2rem 2.25rem;
  }

  @include max-md {
    position: static;
    min-height: auto;
    padding: 2rem 1rem;
  }

  :global {
    .priceBox {
      &__title {
        margin-bottom: 1.5rem;
        font-family: $font-serif;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.75;

        @include max-md {
          margin-bottom: 0.5rem;
        }
      }
    }
  }
  &.isPriceBoxDingBeauty {
    padding: 0;
    background: transparent linear-gradient(0deg, #000000cc 0%, #00000000 100%) 0% 0% no-repeat padding-box;
  }
}
</style>
